<template>
  <div class="main-wrapper">
    <div class="head-video">
      <router-link
        v-if="list[0].video !== null"
        :to="
          $i18nRoute({
            name: 'NewsDetail',
            params: { slug: list[0].url }
          })
        "
        class="player-btn"
      >
        <svg
          width="124"
          height="64"
          viewBox="0 0 124 64"
          xmlns="http://www.w3.org/2000/svg"
          style="border-radius: 4px"
        >
          <rect x="0.5" y="0.5" width="123" height="63" rx="3.5" />
          <rect
            x="0.5"
            y="0.5"
            width="123"
            height="63"
            rx="3.5"
            ref="rectVideo"
            stroke-width="4"
            style="transition: all 0.4s"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <g clip-path="url(#clip0)">
            <path
              d="M71.4723 32L57.625 39.7532V24.2468L71.4723 32Z"
              stroke-width="11"
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect
                width="32.1482"
                height="32"
                fill="white"
                transform="translate(50.5195 16)"
              />
            </clipPath>
          </defs>
        </svg>
      </router-link>
      <div class="bg-video">
        <div
          style="width: 100%; height: 100%; position: relative"
          v-if="list[0].video !== null"
        >
          <video
            ref="video"
            :src="list[0].video"
            loop
            muted
            autoplay
            @timeupdate="updateVideoInfo"
          ></video>
        </div>

        <img v-else :src="list[0].image.large" alt="" />
        <div class="overlay-background"></div>
      </div>
      <router-link
        :to="
          $i18nRoute({
            name: 'NewsDetail',
            params: { slug: list[0].url }
          })
        "
      >
        <div class="head-video__descr">
          <div class="head-video__data">
            <div class="data-video-desctop">
              <span class="day"
                >{{ handleDate(list[0].pub_date, "dd mmmm") }}
              </span>
            </div>
          </div>
          <div>
            <div class="head-video__category">
              {{ list[0].sub_category.name }}
            </div>
            <div class="head-video__title limited-text">
              {{ list[0].title }}
            </div>
            <div class="data-video">
              <span class="day">{{ handleDate(list[0].pub_date) }},</span>
              <span class="time">{{ handleTime(list[0].pub_date) }}</span>
            </div>
          </div>
        </div>
      </router-link>

      <Carousel class="carousel-component" />
    </div>
    <div class="bottom-video">
      <router-link
        :to="
          $i18nRoute({
            name: 'NewsDetail',
            params: { slug: item.url }
          })
        "
        v-for="(item, index) in list.slice(1, 12)"
        :key="item.id"
        class="bottom-video__item"
      >
        <div class="card" :class="`card-${index + 1}`">
          <div class="card__img">
            <div class="card__category">{{ item.sub_category.name }}</div>
            <ImageContainer
              :src="item.image.medium"
              :thumb="item.image.thumbnail"
              :alt="item.title"
            />
            <i v-if="item.video" class="fas fa-play-circle icon-player"></i>
          </div>
          <div class="card__descr">
            <div class="card__title limited-text">{{ item.title }}</div>
            <div class="data-news">
              <span class="day">{{ handleDate(item.pub_date) }},</span>
              <span class="time">{{ handleTime(item.pub_date) }}</span>
            </div>
          </div>
        </div>
      </router-link>
      <div class="background-white"></div>
    </div>
  </div>

  <!-- <div
    style="position: absolute;top: 0 left: 0; background: blue; width: 500px; height: 50vh"
  >
    <CarouselTest />
  </div> -->
</template>

<script>
import { useFormatter } from "@/utils/formatter";
import ImageContainer from "@/components/ImageContainer";
import Carousel from "./Carousel.vue";
import { ref } from "@vue/reactivity";
// import CarouselTest from "./CarouselTest.vue";

export default {
  components: { ImageContainer, Carousel },
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  setup() {
    let video = ref(false);
    let rectVideo = ref(null);

    const updateVideoInfo = () => {
      const currentTime = video.value.currentTime;
      const totalTime = video.value.duration;
      const lengthRectSvg = rectVideo.value.getTotalLength();

      rectVideo.value.style.strokeDasharray = lengthRectSvg;
      rectVideo.value.style.strokeDashoffset =
        lengthRectSvg - (lengthRectSvg / totalTime) * currentTime;
    };

    return {
      video,
      rectVideo,
      updateVideoInfo,
      ...useFormatter()
    };
  }
};
</script>

<style lang="scss" scoped>
$black-text: var(--secondary-font-color);
$color-category: #939393;

.main-wrapper {
  overflow: hidden;
  width: 100%;
}

.carousel-component {
  width: 24vw;
  height: 18vw;
  @media screen and (max-width: 992px) {
    height: 100%;
    width: 100%;
  }
}

.player-btn {
  position: absolute;
  display: block;
  top: 50%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
  border-radius: 4px;
  cursor: pointer;
  width: 100px;
  height: 100px;
  fill: transparent;
  stroke: var(--primary-font-color);
  transition: all 0.4s;
  &:hover {
    fill: var(--primary-font-color);
    stroke: var(--secondary-font-color);
  }
  @media screen and (max-width: 992px) {
    display: none;
  }
}
.head-video {
  height: 100vh;
  padding-top: calc(var(--header-main-height) + 4vw);
  position: relative;
  @media only screen and (min-width: 1024px) and (orientation: portrait) {
    height: 60vh;
    &__data {
      margin-top: 6rem;
    }
  }
  &__descr {
    width: clamp(375px, 90%, 2560px);
    margin: 0 auto;
  }
  &__title {
    font-family: Roboto;
    font-size: 2.3vw;
    line-height: 2.5vw;
    letter-spacing: 0.03em;
    max-width: 70%;
    margin-top: 2rem;
    color: #f9f9f9;

    @media screen and (max-width: 992px) {
      max-width: 100%;
      font-style: normal;
      font-weight: normal;
      font-size: 27px;
      line-height: 31px;
      text-align: center;
      letter-spacing: 0.03em;
      margin: 0;
    }
  }
  &__category {
    font-family: Open Sans;
    font-size: 18px;
    line-height: 25px;
    color: $color-category;
    margin-top: 1.2rem;
    color: #f9f9f9;
    @media screen and (max-width: 992px) {
      text-align: center;
      font-family: Open Sans;
      font-style: normal;
      font-weight: 600;
      font-size: 13px;
      line-height: 18px;
      color: rgba(255, 255, 255, 0.6);
      margin: 0;
    }
  }
  .data-video-desctop {
    font-family: Open Sans;
    font-size: 28px;
    line-height: 38px;
    color: #f9f9f9;

    @media screen and (max-width: 992px) {
      display: none;
    }
  }
  .data-video {
    display: none;
    @media screen and (max-width: 992px) {
      display: block;
    }
  }

  @media screen and (max-width: 992px) {
    height: 60vh;
    position: relative;
    &__descr {
      width: 70%;
      margin: 0 auto;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%);
    }
    &__title {
      font-family: Roboto;
      font-size: 27px;
      line-height: 31px;
      letter-spacing: 0.03em;
    }
    .data-video {
      text-align: center;
      font-family: Open Sans;
      font-size: 13px;
      line-height: 18px;
      color: #939393;
      margin-top: 8px;
    }
    &__category {
      font-family: Open Sans;
      font-weight: 600;
      font-size: 13px;
      line-height: 18px;
      color: rgba(255, 255, 255, 0.6);
      margin-bottom: 0.5rem;
    }
  }
  @media screen and (max-width: 767px) {
    height: 260px;
    &__descr {
      width: 70%;
      margin: 0 auto;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%);
    }
    &__title {
      text-align: left;
      font-family: Roboto;
      font-size: 27px;
      line-height: 31px;
      letter-spacing: 0.03em;
    }
    .data-video {
      text-align: center;
      font-family: Open Sans;
      font-size: 13px;
      line-height: 18px;
      color: #939393;
      margin-top: 8px;
    }
    &__category {
      font-style: normal;
      font-weight: normal;
      font-size: 10px;
      line-height: 14px;

      color: #f9f9f9;
      margin-bottom: 0.5rem 0;
    }
    &__title {
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 17px;
      line-height: 19px;
      text-align: center;
      letter-spacing: 0.03em;
    }
    .data-video {
      font-family: Open Sans;
      font-style: normal;
      font-weight: normal;
      font-size: 10px;
      line-height: 14px;

      color: rgba(255, 255, 255, 0.7);
    }
  }
  @media screen and (max-width: 375px) {
    &__descr {
      top: 50%;
      .limited-text {
        --snup: 2;
      }
    }
  }
}

.bottom-video {
  max-width: var(--width-media);
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(24, 1fr);
  grid-template-rows: repeat(2, auto) 180px;
  row-gap: 2rem;
  padding-top: 1rem;
  padding-bottom: 2rem;
  @media screen and (max-width: 1400px) {
    grid-template-rows: repeat(2, auto) 150px;
    row-gap: 1rem;
    padding-bottom: 0;
  }

  .icon-player {
    position: absolute;
    bottom: 10px;
    left: 10px;
    font-size: 1.2rem;
    color: var(--primary-font-color);
  }

  @media screen and (max-width: 992px) {
    grid-template-rows: 80px repeat(3, auto);
    row-gap: 1rem;
    // padding: 0 10px;
  }
  @media screen and (max-width: 767px) {
    grid-template-rows: auto;
    width: 100%;
    row-gap: 1rem;
    padding: 1rem 5px;
    margin: 0 auto;
    transform: translateY(-14px);
  }
  &__item {
    z-index: 1;
  }
  &__item:nth-child(1),
  &__item:nth-child(2) {
    grid-column: 1 / span 6;
  }
  &__item:nth-child(1) {
    @media screen and (max-width: 992px) {
      grid-column: 1 / span 25;
      grid-row: 2;
    }
    @media screen and (max-width: 767px) {
      grid-row: 5;
    }
  }
  &__item:nth-child(2) {
    @media screen and (max-width: 992px) {
      grid-column: 1 / span 8;
      grid-row: 3;
    }
    @media screen and (max-width: 767px) {
      grid-column: 1 / span 12;

      grid-row: 3;
    }
  }
  &__item:nth-child(3) {
    grid-column: 8 / span 3;
    transform: translateY(-155px);
    grid-row: 1;
    @media screen and (max-width: 992px) {
      grid-column: 1 / span 8;
    }
    @media screen and (max-width: 767px) {
      grid-column: 1 / span 12;
      transform: translateY(-45px);
    }
  }
  &__item:nth-child(4) {
    grid-column: 12 / span 3;
    grid-row: 1;
    transform: translateY(-155px);
    @media screen and (max-width: 992px) {
      grid-column: 9 / span 8;
    }
    @media screen and (max-width: 767px) {
      grid-column: 13 / span 12;
      transform: translateY(-45px);
    }
  }
  &__item:nth-child(5) {
    grid-column: 16 / span 3;
    grid-row: 1;
    transform: translateY(-155px);
    @media screen and (max-width: 992px) {
      grid-column: 17 / span 8;
    }
    @media screen and (max-width: 767px) {
      grid-column: 1 / span 24;
      grid-row: 2;
      transform: translateY(-25px);
    }
  }
  &__item:nth-child(6),
  &__item:nth-child(8) {
    grid-column: 7 / span 6;
    @media screen and (max-width: 992px) {
      // grid-column: 7 / span 6;
      padding: 0;
    }
  }
  &__item:nth-child(6) {
    grid-row: 2;
    @media screen and (max-width: 992px) {
      grid-column: 9 / span 8;
      grid-row: 3;
    }
    @media screen and (max-width: 767px) {
      grid-column: 13 / span 12;

      // grid-row: 4;
    }
  }
  &__item:nth-child(8) {
    grid-row: 3;
    @media screen and (max-width: 992px) {
      grid-column: 1 / span 8;
      grid-row: 4;
    }
    @media screen and (max-width: 767px) {
      grid-column: 1 / span 12;
    }
  }
  &__item:nth-child(7),
  &__item:nth-child(9) {
    grid-column: 14 / span 6;
  }
  &__item:nth-child(7) {
    grid-row: 3;
    @media screen and (max-width: 992px) {
      grid-column: 17 / span 8;
      grid-row: 3;
    }
    @media screen and (max-width: 767px) {
      grid-column: 1 / span 12;
      grid-row: 6;
    }
  }
  &__item:nth-child(9) {
    grid-row: 2;
    @media screen and (max-width: 992px) {
      grid-column: 9 / span 8;
      grid-row: 4;
    }
    @media screen and (max-width: 767px) {
      grid-column: 13 / span 12;
    }
  }
  &__item:nth-child(10),
  &__item:nth-child(11) {
    grid-column: 20 / span 6;
  }
  &__item:nth-child(10) {
    grid-row: 1;
    @media screen and (max-width: 992px) {
      grid-column: 17 / span 8;
      grid-row: 4;
    }
    @media screen and (max-width: 767px) {
      grid-column: 13 / span 12;
      grid-row: 6;
    }
  }
  &__item:nth-child(11) {
    grid-row: 2;
    @media screen and (max-width: 992px) {
      grid-column: 1 / span 25;
      grid-row: 5;
    }
    @media screen and (max-width: 767px) {
      // grid-column: 13 / span 12;
      grid-row: 7;
    }
  }
}
.background-white {
  background: var(--primary-font-color);
  grid-column: 7 / span 13;
  grid-row: 1 / span 3;
  transform: translateY(-100px);
  z-index: 0;
  border-radius: 4px;
  height: 103%;
  @media screen and (max-width: 992px) {
    grid-column: 1 / span 24;
    grid-row: 1 /6;
    height: 108%;
  }
  @media screen and (max-width: 767px) {
    transform: translateY(0px);
    grid-row: 1 / span 7;
    height: 101%;
  }
}

.card {
  &__title {
    margin-top: 0.5rem;
    font-family: Roboto;
    font-weight: 400;
    font-size: calc(min(1.25em, 1vw));
    line-height: 1.3em;
    @media screen and (max-width: 1100px) {
      font-size: calc(min(1.25em, 1.3vw));
    }
    @media screen and (max-width: 992px) {
      font-style: normal;
      font-size: 16px;
      line-height: 22px;
    }
    @media screen and (max-width: 767px) {
      font-size: 12px;
      line-height: 15px;
    }
  }
  .data-news {
    font-family: Open Sans;
    font-size: calc(min(0.9em, 0.85vw));
    line-height: 19px;
    margin-top: 8px;
    @media screen and (max-width: 992px) {
      font-size: 13px;
      line-height: 18px;
      color: var(--category-color);
    }
    @media screen and (max-width: 767px) {
      font-size: 10px;
      line-height: 14px;
    }
  }
  &__img {
    position: relative;
    border-radius: 4px;
    overflow: hidden;
  }
  &__category {
    position: absolute;
    z-index: 3;
    font-family: Open Sans;
    font-size: 0.88em;
    line-height: 19px;
    color: var(--category-color);
    background: var(--black-bg);
    padding: 3px;
    @media screen and (max-width: 992px) {
      font-family: Open Sans;
      font-weight: 600;
      font-size: 13px;
      line-height: 18px;
      text-transform: uppercase;
    }
    @media screen and (max-width: 767px) {
      font-family: Open Sans;
      font-weight: 600;
      font-size: 10px;
      line-height: 14px;
    }
  }
}
.card-1,
.card-2,
.card-11,
.card-10 {
  padding: 0 1rem;
  @media screen and (max-width: 767px) {
    padding: 0 0.5rem;
  }
  .card__img {
    height: 13vw;
  }
  .card__category {
    background-color: $black-text;
    @media screen and (max-width: 992px) {
      background-color: var(--primary-font-color);
    }
  }
  @media screen and (max-width: 992px) {
    color: $black-text;

    .card__img {
      height: 124px;
    }
  }
}
.card-1 {
  @media screen and (max-width: 992px) {
    padding: 0;
    text-align: center;

    .card__img {
      height: 425px;
      margin: 0 -5px;
      text-align: left;
    }
  }
  @media screen and (max-width: 767px) {
    text-align: center;
    .card__img {
      height: 195px;
      text-align: left;
      margin: 0 -2px;
    }
  }
}
.card-6,
.card-7,
.card-8,
.card-9 {
  transform: translateY(-75%);
  padding: 0 1.5rem;
  color: $black-text;

  .card__img {
    height: 12vw;
  }
  .card__category {
    background: var(--primary-font-color);
  }
  @media screen and (max-width: 992px) {
    transform: translateY(0px);
    padding: 0 1rem;
    @media screen and (max-width: 992px) {
      .card__img {
        height: 124px;
      }
    }
  }
  @media screen and (max-width: 767px) {
    padding: 0 0.5rem;
  }
}
.card-3,
.card-4,
.card-5 {
  color: $black-text;
  .card__img {
    height: 6vw;
    min-height: 122px;
    .icon-player {
      right: 10px;
      left: auto;
    }
  }
  .card__category {
    background: var(--primary-font-color);
    color: #939393;
    bottom: 0;
  }
  .card__title {
    --snup: 4;
  }
  @media screen and (max-width: 992px) {
    padding: 0 1rem;
    .card__category {
      bottom: 0;
    }
  }
  @media screen and (max-width: 767px) {
    padding: 0 0.5rem;
  }
}
.card-3 {
  @media screen and (max-width: 992px) {
    padding-left: 2rem;
  }
  @media screen and (max-width: 767px) {
    padding: 0 0.5rem;
  }
}
.card-5 {
  @media screen and (max-width: 992px) {
    padding-right: 2rem;
  }
  @media screen and (max-width: 767px) {
    text-align: center;
    padding: 0;
    .card__img {
      margin: 0 -2px;

      height: 195px;
      text-align: left;
    }
  }
}
.card-11 {
  @media screen and (max-width: 992px) {
    padding: 0;
    color: $black-text;
    text-align: center;
    .card__img {
      text-align: left;
      margin: 0 -5px;
      height: 425px;
    }
  }
  @media screen and (max-width: 767px) {
    // padding: 0 0.5rem;
    .card__img {
      margin: 0 -2px;
      height: 195px;
    }
  }
}
.bg-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.overlay-background {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  z-index: 0;
  background: linear-gradient(
    0deg,
    rgba(18, 18, 18, 0.45),
    rgba(18, 18, 18, 0.45)
  );
}
@media screen and (max-width: 767px) {
  .card-6,
  .card-7,
  .card-8,
  .card-9,
  .card-10,
  .card-2,
  .card-3,
  .card-4 {
    .card__img {
      min-height: auto;
      height: auto;
      .main-image {
        padding-bottom: 55%;
      }

      .icon-player {
        left: auto;
        right: 10px;
      }
      .card__category {
        bottom: 0;
      }
    }
  }
  .card-3,
  .card-4 {
    transform: translateY(25px);
  }
  .card-5 {
    transform: translateY(10px);
    .card__category {
      top: 0;
      bottom: auto;
    }
  }
}
</style>
